import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ubuntu': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM300.7 101c-8.8 15.2-3.6 34.7 11.7 43.6 15.2 8.8 34.7 3.5 43.5-11.7 8.8-15.3 3.6-34.8-11.7-43.6-15.2-8.8-34.7-3.5-43.5 11.7zM87.4 287.9c17.6 0 31.9-14.3 31.9-31.9s-14.3-31.9-31.9-31.9c-17.6 0-31.9 14.3-31.9 31.9s14.3 31.9 31.9 31.9zM115.5 291c8.7 32.7 29.1 60.7 56.5 79l23.7-39.6c-51.5-36.3-51.5-112.5 0-148.8l-23.7-39.6c-27.4 18.4-47.9 46.3-56.5 79.1 22.4 18 22.3 52 0 69.9zM344.2 422.7c15.3-8.8 20.5-28.3 11.7-43.6-8.8-15.3-28.3-20.5-43.5-11.7-15.3 8.8-20.5 28.3-11.7 43.6s28.2 20.5 43.5 11.7zM344.5 353.2c23-22.9 38-53.9 40.3-88.4l-46.1-0.7c-5.5 62.7-71.9 100.9-128.9 74.4l-22.5 40.3c47.8 23.7 91.5 10.8 96.7 9.4 4.4-28.4 33.8-45.3 60.5-35zM338.6 247.9l46-0.6c-2.2-34.6-17.1-65.6-40.2-88.5-26.7 10.3-56.1-6.7-60.5-35-5.2-1.4-48.8-14.3-96.7 9.4l22.5 40.3c57.6-26.8 123.5 12.4 128.9 74.4z'
      }
    ]
  }
})
